<dynamic-form
  [group]="group"
  [serviceName]="'FourEyesAdminPanelService'"
  [loading]="loading"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  [formErrors]="formErrors"
  #form="dynamicForm"
  (submit)="submit($event)"
  (modalOutput)="handleModalOutput($event)"
  (formChanges)="handleFormChanges($event)"
>
</dynamic-form>

<base-table-layout
  [records]="grid"
  [footer]="footer"
  [gridActions]="gridActions"
  [hasRowCheckbox]="hasRowCheckbox"
  [settings]="columnSetting"
  [searched]="searched"
  [loading]="loading"
  [downloading]="downloading"
  [checkboxLoading]="checkboxLoading"
  [count]="count"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  (outputMethodHandler)="outputMethodHandler($event)"
  [sortNum]="sortNum"
  [sortDir]="sortDir"
  (changeSortHandler)="changeSort($event)"
  [pageSize]="pageSize"
  [pageNum]="pageNum"
  [pageMax]="pageMax"
  (changePageHandler)="changePage($event)"
  (changePageSizeHandler)="changePageSize($event)"
>
</base-table-layout>

<div
  bsModal
  #detailsModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="detailsModal.hide()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card card-accent-primary shadowed">
          <div class="card-block">
            <form [formGroup]="detailsForm" *ngIf="!loading">
              <div class="form-group">
                <label
                  for="foureyesEnabled"
                  class="form-control-label"
                  >{{ visuals.foureyesEnabled }}</label
                >
                <ng-select
                  id="foureyesEnabled"
                  [ngClass]="{'errorField': detailsForm.controls['foureyesEnabled'].errors?.required}"
                  #ngSelect
                  [items]="yN"
                  bindValue="id"
                  bindLabel="text"
                  [formControlName]="'foureyesEnabled'"
                ></ng-select>
                <div class="error" *ngIf="detailsForm.controls['foureyesEnabled'].errors?.required">
                  {{ genericVisuals.required }}
                </div>
              </div>
              <div class="form-group">
                <label for="model" class="form-control-label">{{ visuals.isSixEyes }}</label>
                <ng-select
                  id="model"
                  [ngClass]="{'errorField': detailsForm.controls['isSixEyes'].errors?.required}"
                  #ngSelect
                  [items]="model"
                  bindValue="id"
                  bindLabel="text"
                  [formControlName]="'isSixEyes'"
                ></ng-select>
                <div class="error" *ngIf="detailsForm.controls['isSixEyes'].errors?.required">
                  {{ genericVisuals.required }}
                </div>
              </div>
              <div class="form-group">
                <label for="authRole1" class="form-control-label">{{ visuals.authRole1 }}</label>
                <ng-select
                  id="authRole1"
                  [ngClass]="{'errorField': detailsForm.controls['authRoleId1'].errors?.required}"
                  #ngSelect
                  [items]="roles"
                  bindValue="id"
                  bindLabel="text"
                  [formControlName]="'authRoleId1'"
                ></ng-select>
                <div class="error" *ngIf="detailsForm.controls['authRoleId1'].errors?.required">
                  {{ genericVisuals.required }}
                </div>
              </div>
              <div class="form-group">
                <label for="authRole2" class="form-control-label">{{ visuals.authRole2 }}</label>
                <ng-select
                  id="authRole2"
                  [ngClass]="{'errorField': detailsForm.controls['authRoleId2'].errors?.required}"
                  #ngSelect
                  [items]="roles"
                  bindValue="id"
                  bindLabel="text"
                  [formControlName]="'authRoleId2'"
                ></ng-select>
                <div class="error" *ngIf="detailsForm.controls['authRoleId2'].errors?.required">
                  {{ genericVisuals.required }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          (click)="detailsModal.hide()"
        >
          {{ genericVisuals.close }}
        </button>
        <button
          type="button"
          class="btn btn-success"
          data-dismiss="modal"
          (click)="saveDetails()"
          [disabled]="detailsForm.invalid"
        >
          {{ genericVisuals.submit }}
        </button>
      </div>
    </div>
  </div>
</div>
